<template>
  <mdb-container fluid>
    <!--Section: Hover effects-->
    <section>
      <h2 class="mt-lg-5 mb-5 font-weight-bold">
        <strong>Hover effects</strong>
      </h2>

      <!--Grid row-->
      <div class="row mt-5">
        <!--Grid column-->
        <div class="col-lg-4 col-md-12 mb-4">
          <div class="view overlay">
            <img
              src="https://mdbootstrap.com/img/Photos/Others/forest-sm.jpg"
              class="img-fluid "
              alt=""
            />
            <div class="mask flex-center rgba-red-strong">
              <p class="white-text">Strong overlay</p>
            </div>
          </div>
        </div>
        <!--Grid column-->

        <!--Grid column-->
        <div class="col-lg-4 col-md-6 mb-4">
          <div class="view overlay">
            <img
              src="https://mdbootstrap.com/img/Photos/Others/forest-sm.jpg"
              class="img-fluid "
              alt=""
            />
            <div class="mask flex-center rgba-red-light">
              <p class="white-text">Light overlay</p>
            </div>
          </div>
        </div>
        <!--Grid column-->

        <!--Grid column-->
        <div class="col-lg-4 col-md-6 mb-4">
          <div class="view overlay">
            <img
              src="https://mdbootstrap.com/img/Photos/Others/forest-sm.jpg"
              class="img-fluid "
              alt=""
            />
            <div class="mask flex-center rgba-red-slight">
              <p class="white-text">Super light overlay</p>
            </div>
          </div>
        </div>
        <!--Grid column-->
      </div>
      <!--Grid row-->

      <!--Grid row-->
      <div class="row">
        <!--Grid column-->
        <div class="col-md-6 mb-4">
          <!--Zoom effect-->
          <div class="view overlay zoom">
            <img
              src="https://mdbootstrap.com/img/Photos/Horizontal/Nature/6-col/img%20(131).jpg"
              class="img-fluid "
              alt=""
            />
            <div class="mask flex-center waves-effect waves-light">
              <p class="white-text">Zoom effect</p>
            </div>
          </div>
        </div>
        <!--Grid column-->

        <!--Grid column-->
        <div class="col-md-5 mb-4">
          <h4 class="text-center">Shadow effect</h4>
          <br />

          <img
            src="https://mdbootstrap.com/img/Photos/Horizontal/Nature/6-col/img%20(132).jpg"
            class="img-fluid rounded-circle hoverable"
            alt=""
          />
        </div>
        <!--Grid column-->
      </div>
      <!--Grid row-->
    </section>
    <!--Section: Hover effects-->

    <hr class="my-5" />

    <!--Section: Colors and intensity-->
    <section>
      <!--Title-->
      <h4 class="my-5 font-weight-bold dark-grey-text">
        <strong>Colors and intensity</strong>
      </h4>

      <!--Description-->
      <p class="description">
        Use one of the classes below to change the color and intensity of the
        overlay.
      </p>

      <!--Section: Live preview-->
      <section>
        <h4>Light overlay</h4>
        <br />
        <div class="row">
          <div class="col-md-2">
            <div class="view overlay">
              <img
                src="https://mdbootstrap.com/img/Photos/Horizontal/Nature/4-col/img%20(115).jpg"
                class="img-fluid"
                alt="Image with a light blue overlay."
              />
              <div class="mask rgba-blue-light"></div>
            </div>
            <p class="text-center"><code>.rgba-blue-light</code></p>
          </div>

          <div class="col-md-2">
            <div class="view overlay">
              <img
                src="https://mdbootstrap.com/img/Photos/Horizontal/Nature/4-col/img%20(115).jpg"
                class="img-fluid"
                alt="Image with a light red overlay."
              />
              <div class="mask rgba-red-light"></div>
            </div>
            <p class="text-center"><code>.rgba-red-light</code></p>
          </div>

          <div class="col-md-2">
            <div class="view overlay">
              <img
                src="https://mdbootstrap.com/img/Photos/Horizontal/Nature/4-col/img%20(115).jpg"
                class="img-fluid"
                alt="Image with a light pink overlay."
              />
              <div class="mask rgba-pink-light"></div>
            </div>
            <p class="text-center"><code>.rgba-pink-light</code></p>
          </div>

          <div class="col-md-2">
            <div class="view overlay">
              <img
                src="https://mdbootstrap.com/img/Photos/Horizontal/Nature/4-col/img%20(115).jpg"
                class="img-fluid"
                alt="Image with a light purple overlay."
              />
              <div class="mask rgba-purple-light"></div>
            </div>
            <p class="text-center"><code>.rgba-purple-light</code></p>
          </div>

          <div class="col-md-2">
            <div class="view overlay">
              <img
                src="https://mdbootstrap.com/img/Photos/Horizontal/Nature/4-col/img%20(115).jpg"
                class="img-fluid"
                alt="Image with a light indigo overlay."
              />
              <div class="mask rgba-indigo-light"></div>
            </div>
            <p class="text-center"><code>.rgba-indigo-light</code></p>
          </div>

          <div class="col-md-2">
            <div class="view overlay">
              <img
                src="https://mdbootstrap.com/img/Photos/Horizontal/Nature/4-col/img%20(115).jpg"
                class="img-fluid"
                alt="Image with a light cyan overlay."
              />
              <div class="mask rgba-cyan-light"></div>
            </div>
            <p class="text-center"><code>.rgba-cyan-light</code></p>
          </div>
        </div>

        <div class="row">
          <div class="col-md-2">
            <div class="view overlay">
              <img
                src="https://mdbootstrap.com/img/Photos/Horizontal/Nature/4-col/img%20(115).jpg"
                class="img-fluid"
                alt="Image with a light teal overlay."
              />
              <div class="mask rgba-teal-light"></div>
            </div>
            <p class="text-center"><code>.rgba-teal-light</code></p>
          </div>

          <div class="col-md-2">
            <div class="view overlay">
              <img
                src="https://mdbootstrap.com/img/Photos/Horizontal/Nature/4-col/img%20(115).jpg"
                class="img-fluid"
                alt="Image with a light green overlay."
              />
              <div class="mask rgba-green-light"></div>
            </div>
            <p class="text-center"><code>.rgba-green-light</code></p>
          </div>

          <div class="col-md-2">
            <div class="view overlay">
              <img
                src="https://mdbootstrap.com/img/Photos/Horizontal/Nature/4-col/img%20(115).jpg"
                class="img-fluid"
                alt="Image with a light lime overlay."
              />
              <div class="mask rgba-lime-light"></div>
            </div>
            <p class="text-center"><code>.rgba-lime-light</code></p>
          </div>

          <div class="col-md-2">
            <div class="view overlay">
              <img
                src="https://mdbootstrap.com/img/Photos/Horizontal/Nature/4-col/img%20(115).jpg"
                class="img-fluid"
                alt="Image with a light yellow overlay."
              />
              <div class="mask rgba-yellow-light"></div>
            </div>
            <p class="text-center"><code>.rgba-yellow-light</code></p>
          </div>

          <div class="col-md-2">
            <div class="view overlay">
              <img
                src="https://mdbootstrap.com/img/Photos/Horizontal/Nature/4-col/img%20(115).jpg"
                class="img-fluid"
                alt="Image with a light orange overlay."
              />
              <div class="mask rgba-orange-light"></div>
            </div>
            <p class="text-center"><code>.rgba-orange-light</code></p>
          </div>

          <div class="col-md-2">
            <div class="view overlay">
              <img
                src="https://mdbootstrap.com/img/Photos/Horizontal/Nature/4-col/img%20(115).jpg"
                class="img-fluid"
                alt="Image with a light brown overlay."
              />
              <div class="mask rgba-brown-light"></div>
            </div>
            <p class="text-center"><code>.rgba-brown-light</code></p>
          </div>
        </div>

        <div class="row">
          <div class="col-md-2">
            <div class="view overlay">
              <img
                src="https://mdbootstrap.com/img/Photos/Horizontal/Nature/4-col/img%20(115).jpg"
                class="img-fluid"
                alt="Image with a light grey overlay."
              />
              <div class="mask rgba-grey-light"></div>
            </div>
            <p class="text-center"><code>.rgba-grey-light</code></p>
          </div>

          <div class="col-md-2">
            <div class="view overlay">
              <img
                src="https://mdbootstrap.com/img/Photos/Horizontal/Nature/4-col/img%20(115).jpg"
                class="img-fluid"
                alt="Image with a light blue-grey overlay."
              />
              <div class="mask rgba-blue-grey-light"></div>
            </div>
            <p class="text-center"><code>.rgba-blue-grey-light</code></p>
          </div>

          <div class="col-md-2">
            <div class="view overlay">
              <img
                src="https://mdbootstrap.com/img/Photos/Horizontal/Nature/4-col/img%20(115).jpg"
                class="img-fluid"
                alt="Image with a light black overlay."
              />
              <div class="mask rgba-black-light"></div>
            </div>
            <p class="text-center"><code>.rgba-black-light</code></p>
          </div>

          <div class="col-md-2">
            <div class="view overlay">
              <img
                src="https://mdbootstrap.com/img/Photos/Horizontal/Nature/4-col/img%20(115).jpg"
                class="img-fluid"
                alt="Image with a light stylish overlay."
              />
              <div class="mask rgba-stylish-light"></div>
            </div>
            <p class="text-center"><code>.rgba-stylish-light</code></p>
          </div>

          <div class="col-md-2">
            <div class="view overlay">
              <img
                src="https://mdbootstrap.com/img/Photos/Horizontal/Nature/4-col/img%20(115).jpg"
                class="img-fluid"
                alt="Image with a light white overlay."
              />
              <div class="mask rgba-white-light"></div>
            </div>
            <p class="text-center"><code>.rgba-white-light</code></p>
          </div>
        </div>

        <h4>Strong overlay</h4>
        <br />
        <div class="row">
          <div class="col-md-2">
            <div class="view overlay">
              <img
                src="https://mdbootstrap.com/img/Photos/Horizontal/Nature/4-col/img%20(31).jpg"
                class="img-fluid"
                alt="Image with a strong blue overlay."
              />
              <div class="mask rgba-blue-strong"></div>
            </div>
            <p class="text-center"><code>.rgba-blue-strong</code></p>
          </div>

          <div class="col-md-2">
            <div class="view overlay">
              <img
                src="https://mdbootstrap.com/img/Photos/Horizontal/Nature/4-col/img%20(31).jpg"
                class="img-fluid"
                alt="Image with a strong red overlay."
              />
              <div class="mask rgba-red-strong"></div>
            </div>
            <p class="text-center"><code>.rgba-red-strong</code></p>
          </div>

          <div class="col-md-2">
            <div class="view overlay">
              <img
                src="https://mdbootstrap.com/img/Photos/Horizontal/Nature/4-col/img%20(31).jpg"
                class="img-fluid"
                alt="Image with a strong pink overlay."
              />
              <div class="mask rgba-pink-strong"></div>
            </div>
            <p class="text-center"><code>.rgba-pink-strong</code></p>
          </div>

          <div class="col-md-2">
            <div class="view overlay">
              <img
                src="https://mdbootstrap.com/img/Photos/Horizontal/Nature/4-col/img%20(31).jpg"
                class="img-fluid"
                alt="Image with a strong purple overlay."
              />
              <div class="mask rgba-purple-strong"></div>
            </div>
            <p class="text-center"><code>.rgba-purple-strong</code></p>
          </div>

          <div class="col-md-2">
            <div class="view overlay">
              <img
                src="https://mdbootstrap.com/img/Photos/Horizontal/Nature/4-col/img%20(31).jpg"
                class="img-fluid"
                alt="Image with a strong indigo overlay."
              />
              <div class="mask rgba-indigo-strong"></div>
            </div>
            <p class="text-center"><code>.rgba-indigo-strong</code></p>
          </div>

          <div class="col-md-2">
            <div class="view overlay">
              <img
                src="https://mdbootstrap.com/img/Photos/Horizontal/Nature/4-col/img%20(31).jpg"
                class="img-fluid"
                alt="Image with a strong cyan overlay."
              />
              <div class="mask rgba-cyan-strong"></div>
            </div>
            <p class="text-center"><code>.rgba-cyan-strong</code></p>
          </div>
        </div>

        <div class="row">
          <div class="col-md-2">
            <div class="view overlay">
              <img
                src="https://mdbootstrap.com/img/Photos/Horizontal/Nature/4-col/img%20(31).jpg"
                class="img-fluid"
                alt="Image with a strong teal overlay."
              />
              <div class="mask rgba-teal-strong"></div>
            </div>
            <p class="text-center"><code>.rgba-teal-strong</code></p>
          </div>

          <div class="col-md-2">
            <div class="view overlay">
              <img
                src="https://mdbootstrap.com/img/Photos/Horizontal/Nature/4-col/img%20(31).jpg"
                class="img-fluid"
                alt="Image with a strong green overlay."
              />
              <div class="mask rgba-green-strong"></div>
            </div>
            <p class="text-center"><code>.rgba-green-strong</code></p>
          </div>

          <div class="col-md-2">
            <div class="view overlay">
              <img
                src="https://mdbootstrap.com/img/Photos/Horizontal/Nature/4-col/img%20(31).jpg"
                class="img-fluid"
                alt="Image with a strong lime overlay."
              />
              <div class="mask rgba-lime-strong"></div>
            </div>
            <p class="text-center"><code>.rgba-lime-strong</code></p>
          </div>

          <div class="col-md-2">
            <div class="view overlay">
              <img
                src="https://mdbootstrap.com/img/Photos/Horizontal/Nature/4-col/img%20(31).jpg"
                class="img-fluid"
                alt="Image with a strong yellow overlay."
              />
              <div class="mask rgba-yellow-strong"></div>
            </div>
            <p class="text-center"><code>.rgba-yellow-strong</code></p>
          </div>

          <div class="col-md-2">
            <div class="view overlay">
              <img
                src="https://mdbootstrap.com/img/Photos/Horizontal/Nature/4-col/img%20(31).jpg"
                class="img-fluid"
                alt="Image with a strong orange overlay."
              />
              <div class="mask rgba-orange-strong"></div>
            </div>
            <p class="text-center"><code>.rgba-orange-strong</code></p>
          </div>

          <div class="col-md-2">
            <div class="view overlay">
              <img
                src="https://mdbootstrap.com/img/Photos/Horizontal/Nature/4-col/img%20(31).jpg"
                class="img-fluid"
                alt="Image with a strong brown overlay."
              />
              <div class="mask rgba-brown-strong"></div>
            </div>
            <p class="text-center"><code>.rgba-brown-strong</code></p>
          </div>
        </div>

        <div class="row">
          <div class="col-md-2">
            <div class="view overlay">
              <img
                src="https://mdbootstrap.com/img/Photos/Horizontal/Nature/4-col/img%20(31).jpg"
                class="img-fluid"
                alt="Image with a strong grey overlay."
              />
              <div class="mask rgba-grey-strong"></div>
            </div>
            <p class="text-center"><code>.rgba-grey-strong</code></p>
          </div>

          <div class="col-md-2">
            <div class="view overlay">
              <img
                src="https://mdbootstrap.com/img/Photos/Horizontal/Nature/4-col/img%20(31).jpg"
                class="img-fluid"
                alt="Image with a strong blue-grey overlay."
              />
              <div class="mask rgba-blue-grey-strong"></div>
            </div>
            <p class="text-center"><code>.rgba-blue-grey-strong</code></p>
          </div>

          <div class="col-md-2">
            <div class="view overlay">
              <img
                src="https://mdbootstrap.com/img/Photos/Horizontal/Nature/4-col/img%20(31).jpg"
                class="img-fluid"
                alt="Image with a strong black overlay."
              />
              <div class="mask rgba-black-strong"></div>
            </div>
            <p class="text-center"><code>.rgba-black-strong</code></p>
          </div>

          <div class="col-md-2">
            <div class="view overlay">
              <img
                src="https://mdbootstrap.com/img/Photos/Horizontal/Nature/4-col/img%20(31).jpg"
                class="img-fluid"
                alt="Image with a strong stylish overlay."
              />
              <div class="mask rgba-stylish-strong"></div>
            </div>
            <p class="text-center"><code>.rgba-stylish-strong</code></p>
          </div>

          <div class="col-md-2">
            <div class="view overlay">
              <img
                src="https://mdbootstrap.com/img/Photos/Horizontal/Nature/4-col/img%20(31).jpg"
                class="img-fluid"
                alt="Image with a strong white overlay."
              />
              <div class="mask rgba-white-strong"></div>
            </div>
            <p class="text-center"><code>.rgba-white-strong</code></p>
          </div>
        </div>
        <br />
        <br />

        <h4>Super Light overlay</h4>
        <br />
        <div class="row">
          <div class="col-md-2">
            <div class="view overlay">
              <img
                src="https://mdbootstrap.com/img/Photos/Others/forest-sm.jpg"
                class="img-fluid"
                alt="Image with a super light blue overlay."
              />
              <div class="mask rgba-blue-slight"></div>
            </div>
            <p class="text-center"><code>.rgba-blue-slight</code></p>
          </div>

          <div class="col-md-2">
            <div class="view overlay">
              <img
                src="https://mdbootstrap.com/img/Photos/Others/forest-sm.jpg"
                class="img-fluid"
                alt="Image with a super light red overlay."
              />
              <div class="mask rgba-red-slight"></div>
            </div>
            <p class="text-center"><code>.rgba-red-slight</code></p>
          </div>

          <div class="col-md-2">
            <div class="view overlay">
              <img
                src="https://mdbootstrap.com/img/Photos/Others/forest-sm.jpg"
                class="img-fluid"
                alt="Image with a super light pink overlay."
              />
              <div class="mask rgba-pink-slight"></div>
            </div>
            <p class="text-center"><code>.rgba-pink-slight</code></p>
          </div>

          <div class="col-md-2">
            <div class="view overlay">
              <img
                src="https://mdbootstrap.com/img/Photos/Others/forest-sm.jpg"
                class="img-fluid"
                alt="Image with a super light purple overlay."
              />
              <div class="mask rgba-purple-slight"></div>
            </div>
            <p class="text-center"><code>.rgba-purple-slight</code></p>
          </div>

          <div class="col-md-2">
            <div class="view overlay">
              <img
                src="https://mdbootstrap.com/img/Photos/Others/forest-sm.jpg"
                class="img-fluid"
                alt="Image with a super light indigo overlay."
              />
              <div class="mask rgba-indigo-slight"></div>
            </div>
            <p class="text-center"><code>.rgba-indigo-slight</code></p>
          </div>

          <div class="col-md-2">
            <div class="view overlay">
              <img
                src="https://mdbootstrap.com/img/Photos/Others/forest-sm.jpg"
                class="img-fluid"
                alt="Image with a super light cyan overlay."
              />
              <div class="mask rgba-cyan-slight"></div>
            </div>
            <p class="text-center"><code>.rgba-cyan-slight</code></p>
          </div>
        </div>

        <div class="row">
          <div class="col-md-2">
            <div class="view overlay">
              <img
                src="https://mdbootstrap.com/img/Photos/Others/forest-sm.jpg"
                class="img-fluid"
                alt="Image with a super light teal overlay."
              />
              <div class="mask rgba-teal-slight"></div>
            </div>
            <p class="text-center"><code>.rgba-teal-slight</code></p>
          </div>

          <div class="col-md-2">
            <div class="view overlay">
              <img
                src="https://mdbootstrap.com/img/Photos/Others/forest-sm.jpg"
                class="img-fluid"
                alt="Image with a super light green overlay."
              />
              <div class="mask rgba-green-slight"></div>
            </div>
            <p class="text-center"><code>.rgba-green-slight</code></p>
          </div>

          <div class="col-md-2">
            <div class="view overlay">
              <img
                src="https://mdbootstrap.com/img/Photos/Others/forest-sm.jpg"
                class="img-fluid"
                alt="Image with a super light lime overlay."
              />
              <div class="mask rgba-lime-light"></div>
            </div>
            <p class="text-center"><code>.rgba-lime-light</code></p>
          </div>

          <div class="col-md-2">
            <div class="view overlay">
              <img
                src="https://mdbootstrap.com/img/Photos/Others/forest-sm.jpg"
                class="img-fluid"
                alt="Image with a super light yellow overlay."
              />
              <div class="mask rgba-yellow-slight"></div>
            </div>
            <p class="text-center"><code>.rgba-yellow-slight</code></p>
          </div>

          <div class="col-md-2">
            <div class="view overlay">
              <img
                src="https://mdbootstrap.com/img/Photos/Others/forest-sm.jpg"
                class="img-fluid"
                alt="Image with a super light orange overlay."
              />
              <div class="mask rgba-orange-slight"></div>
            </div>
            <p class="text-center"><code>.rgba-orange-slight</code></p>
          </div>

          <div class="col-md-2">
            <div class="view overlay">
              <img
                src="https://mdbootstrap.com/img/Photos/Others/forest-sm.jpg"
                class="img-fluid"
                alt="Image with a super light brown overlay."
              />
              <div class="mask rgba-brown-slight"></div>
            </div>
            <p class="text-center"><code>.rgba-brown-slight</code></p>
          </div>
        </div>

        <div class="row">
          <div class="col-md-2">
            <div class="view overlay">
              <img
                src="https://mdbootstrap.com/img/Photos/Others/forest-sm.jpg"
                class="img-fluid"
                alt="Image with a super light grey overlay."
              />
              <div class="mask rgba-grey-slight"></div>
            </div>
            <p class="text-center"><code>.rgba-grey-slight</code></p>
          </div>

          <div class="col-md-2">
            <div class="view overlay">
              <img
                src="https://mdbootstrap.com/img/Photos/Others/forest-sm.jpg"
                class="img-fluid"
                alt="Image with a super light blue-grey overlay."
              />
              <div class="mask rgba-blue-grey-slight"></div>
            </div>
            <p class="text-center"><code>.rgba-blue-grey-slight</code></p>
          </div>

          <div class="col-md-2">
            <div class="view overlay">
              <img
                src="https://mdbootstrap.com/img/Photos/Others/forest-sm.jpg"
                class="img-fluid"
                alt="Image with a super light black overlay."
              />
              <div class="mask rgba-black-slight"></div>
            </div>
            <p class="text-center"><code>.rgba-black-slight</code></p>
          </div>

          <div class="col-md-2">
            <div class="view overlay">
              <img
                src="https://mdbootstrap.com/img/Photos/Others/forest-sm.jpg"
                class="img-fluid"
                alt="Image with a super light stylish overlay."
              />
              <div class="mask rgba-stylish-slight"></div>
            </div>
            <p class="text-center"><code>.rgba-stylish-slight</code></p>
          </div>

          <div class="col-md-2">
            <div class="view overlay">
              <img
                src="https://mdbootstrap.com/img/Photos/Others/forest-sm.jpg"
                class="img-fluid"
                alt="Image with a super light white overlay."
              />
              <div class="mask rgba-white-slight"></div>
            </div>
            <p class="text-center"><code>.rgba-white-slight</code></p>
          </div>
        </div>
      </section>
      <!--Section: Live preview-->
    </section>
    <!--/Section: Colors and intensity-->

    <!--Section: Docs link-->
    <section>
      <!--Panel-->
      <div class="card text-center mt-5">
        <h3 class="card-header primary-color white-text">Full documentation</h3>
        <div class="card-body">
          <p class="card-text">
            Read the full documentation for these components.
          </p>
          <a
            href="https://mdbootstrap.com/hover-effects/"
            target="_blank"
            class="btn btn-primary"
            >Learn more</a
          >
        </div>
      </div>
      <!--/.Panel-->
    </section>
    <!--Section: Docs link-->
  </mdb-container>
</template>

<script>
import { mdbContainer } from "mdbvue";

export default {
  name: "Blank",
  components: {
    mdbContainer
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
